import React, { useState } from 'react'
import { IArticleVideoPlayList } from './types';
import { Button, FlexGrid, Heading, Responsive, getClassNameFactory } from '@dcl/ui';
import { boldTypes, types } from '@dcl/ui/dist/elements/Heading';
import { ArticleTile } from '../../components/ArticleTiles/components/ArticleTile';
import './ArticleVideoPlayList.css';
import { PlayList } from '../../components/PlaylistTiles/PlayList';
import { ButtonColor, ButtonKind } from '@dcl/ui/dist/elements/Button';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from '../../mock';

export const ArticleVideoPlayList: React.FC<IArticleVideoPlayList> = (
    props: IArticleVideoPlayList
) => {
    const { articles = [], videoPlayList, heading } = props;
    const getClassName = getClassNameFactory(ArticleVideoPlayList.displayName);

    const [showAll, setShowAll] = useState(false);

    const handleShowMore = () => {
        setShowAll(!showAll);
    };

    const displayedArticles = showAll ? articles : articles.slice(0, 3);


    return (
        <div className={getClassName()}>
            <FlexGrid className={getClassName({ descendantName: 'articleVideoPlaylistContainer' })}>
                <FlexGrid.Row className={getClassName({ descendantName: 'headingRow' })}>
                    <FlexGrid.Col
                        xs={12}
                        sm={12}
                        md={12}
                        className={getClassName({ descendantName: 'articleVideoHeading' })}
                    >
                        <Heading type={types.Medium} boldType={boldTypes.medium} className={getClassName({ descendantName: 'articleVideoPlaylistTitleHeading' })}>
                            {heading}
                        </Heading>
                    </FlexGrid.Col>
                </FlexGrid.Row>
            </FlexGrid>
            <FlexGrid className={getClassName({ descendantName: 'articleVideoPlaylistContainer' })}>
                <FlexGrid.Row className={getClassName({ descendantName: 'articleVidePlayListRow' })}>
                    <FlexGrid.Col
                        lg={12}
                        sm={12}
                        md={12}
                        className={getClassName({ descendantName: 'articleVideoHeading' })}
                    >
                        <PlayList {...videoPlayList} />
                    </FlexGrid.Col>
                    {displayedArticles?.map((article, index) => {
                        const keyNo = index + 1;
                        return (
                            <FlexGrid.Col
                                lg={4}
                                sm={4}
                                md={4}
                                className={getClassName({ descendantName: 'articleColumns' })}
                                key={keyNo}
                            >
                                <ArticleTile articleTile={article} />
                            </FlexGrid.Col>
                        )
                    })
                    }
                    <FlexGrid.Col
                        lg={12}
                        sm={12}
                        md={12}
                        className={getClassName({ descendantName: 'articleColumns' })}
                    >
                        {articles.length > 3 && (
                            <div className={getClassName({ descendantName: 'buttonContainer' })}>
                            <Responsive minWidth={DESKTOP_WIDTH}>
                              <Button
                                kind={ButtonKind.BUTTON}
                                color={ButtonColor.SECONDARY}
                                onClick={handleShowMore}
                              >
                                {showAll ? 'Show Less' : 'Show More'}
                              </Button>
                            </Responsive>
                            <Responsive minWidth={0} maxWidth={MOBILE_WIDTH}>
                              <Button
                                kind={ButtonKind.BUTTON}
                                color={ButtonColor.SECONDARY}
                                onClick={handleShowMore}
                                block={true}
                              >
                                {showAll ? 'Show Less' : 'Show More'}
                              </Button>
                            </Responsive>
                          </div>
                        )}
                    </FlexGrid.Col>
                </FlexGrid.Row>
            </FlexGrid>
        </div>
    )
}

ArticleVideoPlayList.displayName = 'ArticleVideoPlayList';